import React from 'react';

export default function Shevron({ className, iconClassName, onClick, disabled }) {
    return (
        <label className={className} onClick={onClick} disabled={disabled}>
            <i className={iconClassName} />
        </label>
    )
}